import React, { useState } from 'react';
import { OrderedListOutlined } from '@ant-design/icons';
import { TrackInfo } from './TrackInfo';
import { Controls } from './Controls';
import ProgressBar from './ProgressBar';
import { VolumeControl } from './VolumeControl';
import { Playlist } from './Playlist';
import classnames from 'classnames';
import { useNuPlayerContext } from '../NuPlayerContext';

const componentClass = 'nutasticAudioPlayer';

export const AudioPlayer = ({ className, onCloseClick, showProgress }) => {
    const { currentTrack, stopTheMusic } = useNuPlayerContext();
    const [openDrawer, setOpenDrawer] = useState(false);
    const classes = classnames(componentClass, className);

    const onCloseButtonClick = () => {
        if (onCloseClick) {
            onCloseClick();
        } else {
            stopTheMusic();
        }
    };

    return currentTrack ? <div className={classes}>
        <div className={`${componentClass}__closeBtn`} onClick={onCloseButtonClick}>
            <i className="ion-md-close-circle"/>
        </div>
        <TrackInfo/>
        <div className={`${componentClass}__controller`}>
            <span>{currentTrack.title} | {currentTrack.author}</span>
            <Controls/>
            {showProgress && <ProgressBar/>}
        </div>
        <div className={`${componentClass}__actions d-none`}>
            <button onClick={() => setOpenDrawer((prev) => !prev)}>
                <OrderedListOutlined/>
            </button>
        </div>

        <div className={openDrawer ? '' : 'd-none'}>
            <Playlist/>
            <VolumeControl/>
        </div>
    </div> : null;
};
